import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_FloatingWindows } from '../../_modules/ModuleFE_FloatingWindows.js';
import './TS_FloatingWindows.scss';
import { TS_FloatingWindow } from '../TS_FloatingWindow/TS_FloatingWindow.js';
export class TS_FloatingWindows extends ComponentSync {
    //######################### Life Cycle #########################
    __onFloatingWindowsUpdated = () => {
        this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.windowModels ??= ModuleFE_FloatingWindows.windowModels;
        return state;
    }
    componentDidUpdate() {
        if (!this.state.windowModels.length)
            TS_FloatingWindow.runningZIndex = 0;
    }
    //######################### Logic #########################
    //######################### Render #########################
    render() {
        if (!this.state.windowModels?.length)
            return;
        return _jsx("div", { id: 'ts-floating-windows', children: this.state.windowModels.map(model => {
                return _jsx(TS_FloatingWindow, { model: model }, model.key);
            }) });
    }
}
//# sourceMappingURL=TS_FloatingWindows.js.map